export default __webpack_public_path__ + "static/media/newseed_logo.6c83d43a.png";